import { topEvents } from './liveFilters';

const codeRegex = '\\(((CPT|CDT|ICD-.+|HCPCS) .+)\\)';
export const getCriteriaCode = item => (item?.toString().match(`${codeRegex}$`) || [])[1];
export const getCriteriaSentance = label => (label?.toString().match(`(.*)${codeRegex}$`) || [null, label])[1];
export const getCriteriaPillTitle = item => {
  var event = Object.values(topEvents)
    .find(f => f.prop === (item.type || '').toLowerCase());
  if (event) {
    return (event.showCode && getCriteriaCode(item.label)) || event.title;
  }
  return null;
}
export const getEventValueLabel = event => {
  if (!event.type)
    return event.label;

  if (event.type.toLowerCase() == 'drugform') {
    return event.brand + ' | ' + event.label;
  }
  if (event.type.toLowerCase() == 'drugstrength') {
    return event.brand + ' | ' + event.form + ' | ' + event.label;
  }

  return event.label;
};
